import { render, staticRenderFns } from "./WidgetLiveMetric.vue?vue&type=template&id=f7e6afc0&scoped=true&"
import script from "./WidgetLiveMetric.vue?vue&type=script&lang=js&"
export * from "./WidgetLiveMetric.vue?vue&type=script&lang=js&"
import style0 from "./WidgetLiveMetric.vue?vue&type=style&index=0&id=f7e6afc0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7e6afc0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f7e6afc0')) {
      api.createRecord('f7e6afc0', component.options)
    } else {
      api.reload('f7e6afc0', component.options)
    }
    module.hot.accept("./WidgetLiveMetric.vue?vue&type=template&id=f7e6afc0&scoped=true&", function () {
      api.rerender('f7e6afc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/stats/widgets/WidgetLiveMetric.vue"
export default component.exports